module.exports = __webpack_public_path__ + "static/media/transition.fd194a76.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Conviot/Develope/video/transition.mp4
// module id = 208
// module chunks = 0